import { isValidHTTPUrl } from "../../../../utils/url-utils";
import { ShortcutDetail } from "../core";
import { TtzkPortalValidationUtil } from "./ttzk-portal-validation-util";

export const ShortcutValidationConstant = {
  MIN_PRIORITY: 1,
  MAX_PRIORITY: 30,
};

export const ShortcutValidationErrors = {
  name: "30文字以内で入力してください",
  description: "120文字以内で入力してください",
  priority: `${String(
    ShortcutValidationConstant.MAX_PRIORITY,
  )}以下の数字で入力してください`,
  url: "1000文字以内のURLを入力してください",
  imageUrl: "1000文字以内のURLを入力してください",
};

export const ShortcutValidator = {
  isValid: (shortcut: ShortcutDetail) => {
    return (
      ShortcutValidator.name(shortcut.name) &&
      ShortcutValidator.description(shortcut.description) &&
      ShortcutValidator.priority(
        shortcut.priority ? String(shortcut.priority) : "",
      ) &&
      ShortcutValidator.url(shortcut.url) &&
      ShortcutValidator.imageUrl(shortcut.imageUrl)
    );
  },
  name: (v: string | null = null) =>
    TtzkPortalValidationUtil.isNotEmptyShorterThan(v || "", 30),
  description: (v: string | null = null) =>
    TtzkPortalValidationUtil.isNotEmptyShorterThan(v || "", 120),
  priority: (v: string) => {
    const min = ShortcutValidationConstant.MIN_PRIORITY;
    const max = ShortcutValidationConstant.MAX_PRIORITY;
    return TtzkPortalValidationUtil.isNumber(v, min, max);
  },
  url: (url: string) => {
    if (
      TtzkPortalValidationUtil.isNotEmptyShorterThan(url || "", 1000) &&
      isValidHTTPUrl(url)
    ) {
      return true;
    }
    return false;
  },
  imageUrl: (url: string) => {
    if (
      TtzkPortalValidationUtil.isNotEmptyShorterThan(url || "", 1000) &&
      isValidHTTPUrl(url)
    ) {
      return true;
    }
    return false;
  },
};
